import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { User, UserCheck } from "lucide-react";
import { Database } from "@/integrations/supabase/types";
import { useTranslation } from "react-i18next";

type Role = Database['public']['Enums']['app_role'];

interface RoleStepProps {
  selectedRole: Role | '';
  setSelectedRole: (role: Role | '') => void;
  onSubmit: () => void;
  isLoading: boolean;
}

export function RoleStep({ selectedRole, setSelectedRole, onSubmit, isLoading }: RoleStepProps) {
  const { t } = useTranslation();

  return (
    <form onSubmit={(e) => { e.preventDefault(); onSubmit(); }} className="space-y-3 sm:space-y-4">
      <div className="space-y-2 sm:space-y-3">
        <Label className="text-sm sm:text-base">{t('onboarding.selectRoleLabel')}</Label>
        <RadioGroup
          onValueChange={(value) => setSelectedRole(value as Role)}
          value={selectedRole}
          className="grid grid-cols-1 gap-2 sm:gap-3"
        >
          <div className="flex items-center space-x-2 p-2 sm:p-3 border rounded-lg hover:bg-gray-50 transition-colors">
            <RadioGroupItem value="talent" id="talent" />
            <Label htmlFor="talent" className="flex items-center gap-2 cursor-pointer text-sm sm:text-base">
              <User className="h-4 w-4" />
              <span>{t('roles.talent')}</span>
            </Label>
          </div>
          <div className="flex items-center space-x-2 p-2 sm:p-3 border rounded-lg hover:bg-gray-50 transition-colors">
            <RadioGroupItem value="recruiter" id="recruiter" />
            <Label htmlFor="recruiter" className="flex items-center gap-2 cursor-pointer text-sm sm:text-base">
              <UserCheck className="h-4 w-4" />
              <span>{t('roles.recruiter')}</span>
            </Label>
          </div>
        </RadioGroup>
      </div>
      <Button type="submit" className="w-full text-sm sm:text-base py-2" disabled={isLoading}>
        {isLoading ? t('onboarding.saving') : t('common.continue')}
      </Button>
    </form>
  );
}